import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Sloven\u0161\u010Dina",
  code: "sl",
  messages: {
    alert: {
      close: "Zapri"
    },
    authForm: {
      hidePassword: "Skrij geslo",
      showPassword: "Prika\u017Ei geslo",
      submit: "Nadaljuj"
    },
    banner: {
      close: "Zapri"
    },
    calendar: {
      nextMonth: "Naslednji mesec",
      nextYear: "Naslednje leto",
      prevMonth: "Prej\u0161nji mesec",
      prevYear: "Prej\u0161nje leto"
    },
    carousel: {
      dots: "Izberite diapozitiv za prikaz",
      goto: "Pojdi na {slide}",
      next: "Naprej",
      prev: "Nazaj"
    },
    chatPrompt: {
      placeholder: "Tukaj napi\u0161ite svoje sporo\u010Dilo..."
    },
    chatPromptSubmit: {
      label: "Po\u0161lji sporo\u010Dilo"
    },
    colorMode: {
      dark: "Temno",
      light: "Svetlo",
      switchToDark: "Preklopi na temni na\u010Din",
      switchToLight: "Preklopi na svetli na\u010Din",
      system: "Sistem"
    },
    commandPalette: {
      back: "Nazaj",
      close: "Zapri",
      noData: "Ni podatkov",
      noMatch: "Ni ujemanj",
      placeholder: "Vpi\u0161i ukaz ali i\u0161\u010Di..."
    },
    contentSearch: {
      links: "Povezave",
      theme: "Tema"
    },
    contentSearchButton: {
      label: "I\u0161\u010Di..."
    },
    contentToc: {
      title: "Na tej strani"
    },
    dashboardSearch: {
      theme: "Tema"
    },
    dashboardSearchButton: {
      label: "I\u0161\u010Di..."
    },
    dashboardSidebarCollapse: {
      collapse: "Strni stransko vrstico",
      expand: "Raz\u0161iri stransko vrstico"
    },
    dashboardSidebarToggle: {
      close: "Zapri stransko vrstico",
      open: "Odpri stransko vrstico"
    },
    error: {
      clear: "Nazaj na doma\u010Do stran"
    },
    fileUpload: {
      removeFile: "Odstrani {filename}"
    },
    header: {
      close: "Zapri meni",
      open: "Odpri meni"
    },
    inputMenu: {
      create: 'Ustvari "{label}"',
      noData: "Ni podatkov",
      noMatch: "Ni ujemanj"
    },
    inputNumber: {
      decrement: "Zmanj\u0161aj",
      increment: "Povi\u0161aj"
    },
    modal: {
      close: "Zapri"
    },
    pricingTable: {
      caption: "Primerjava cenovnih na\u010Drtov"
    },
    prose: {
      codeCollapse: {
        closeText: "Strni",
        name: "koda",
        openText: "Raz\u0161iri"
      },
      collapsible: {
        closeText: "Skrij",
        name: "lastnosti",
        openText: "Prika\u017Ei"
      },
      pre: {
        copy: "Kopiraj kodo v odlo\u017Ei\u0161\u010De"
      }
    },
    selectMenu: {
      create: 'Ustvari "{label}"',
      noData: "Ni podatkov",
      noMatch: "Ni ujemanj",
      search: "I\u0161\u010Di..."
    },
    slideover: {
      close: "Zapri"
    },
    table: {
      noData: "Ni podatkov"
    },
    toast: {
      close: "Zapri"
    }
  }
});
